<template>
  <div class="container-bg-gray">
    <div class="container p-5">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12" data-aos="flip-right">
          <video v-if="videos?.pricing" style="width: 100%" height="350" controls poster="@/assets/images/For-website-Cloverleaf-Overview-2022.png">
            <source :src="videos?.pricing"/>
          </video>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-section" data-aos="flip-left">
          <h4 class=" text-center font-noto-b ">{{ $t('price-text-video')}}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app";
import { computed } from 'vue'

export default {
  setup() {
    const app = useAppStore();

    const videos = computed(() => app.videos);

    return {
      videos,
    }
  }
}
</script>

<style scoped>
  .text-section {
    margin: auto 0;
  }

  .text-section h4 {
    line-height: 40px;
  }
</style>
